import { ReactNode } from 'react'
import { BiCircle, BiRectangle, BiSquare } from 'react-icons/bi'

import { makeId } from '@/utils/makeId'

export type Shape = {
  id: string
  name: string
  icon: ReactNode
}

export const shapes: Shape[] = [
  {
    id: makeId(),
    name: 'Quadrado',
    icon: <BiSquare fontSize={24} />,
  },
  {
    id: makeId(),
    name: 'Retangular',
    icon: <BiRectangle fontSize={24} />,
  },
  {
    id: makeId(),
    name: 'Redondo',
    icon: <BiCircle fontSize={24} />,
  },
  // {
  //   id: makeId(),
  //   name: 'Coração',
  //   icon: <BiHeart fontSize={24} />,
  // },
]
